const React = require('react');
require('./IrrigationRecommendationCard.css');
const $ = require('jquery');
const { useTranslation } = require('react-i18next');
const { getWeekTypeDisplayName } = require('@managers/planningManager');

const IrrigationRecommendationCard = ({
  weekType, // 'this', 'next', 'previous'
  weekRange, // e.g. '(6 Sep - 13 Sep)'
  irrigate,
  frequency,
  dailyReturn,
  onPrev,
  onNext,
  isPrevDisabled,
  isNextDisabled,
  mode,
  user_length_unit = 'mm',
}) => {
  const { t } = useTranslation();
  // Get translated week type display name using planningManager
  const headerTitle = getWeekTypeDisplayName(weekType);

  // Determine label/unit for frequency block
  let frequencyLabel = t('new_planner_recommendation_every');
  let frequencyUnit = t('new_planner_recommendation_days');
  if (mode === 'weekly') {
    frequencyLabel = t('new_planner_recommendation_frequency');
    frequencyUnit = t('new_planner_recommendation_times_a_week');
  }

  return (
    <div className='irrigation-card'>
      <div className='irrigation-card__header'>
        <span>{t(headerTitle)}</span>
        <span className='irrigation-card__date'>{weekRange}</span>
      </div>
      <div
        className={`irrigation-card__stats-row${weekType === 'previous' ? ' irrigation-card__stats-row--disabled' : ''}`}
      >
        <button
          onClick={onPrev}
          disabled={isPrevDisabled}
          aria-label='Previous week'
          className='irrigation-card__arrow'
        >
          <img
            src={require('images/icons/Chevron_left.svg')}
            alt='Previous week'
            style={{ width: 16, height: 16 }}
          />
        </button>
        <div
          style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'space-evenly',
          }}
        >
          <div className='irrigation-card__stat-block'>
            <span className='irrigation-card__stat-label'>
              {t('new_planner_recommendation_irrigate')}
            </span>
            <span className='irrigation-card__stat-value'>{irrigate}</span>
            <span className='irrigation-card__stat-unit'>
              {user_length_unit}
            </span>
          </div>
          <div className='irrigation-card__stat-block'>
            <span className='irrigation-card__stat-label'>
              {frequencyLabel}
            </span>
            <span className='irrigation-card__stat-value'>{frequency}</span>
            <span className='irrigation-card__stat-unit'>{frequencyUnit}</span>
          </div>
          <div className='irrigation-card__divider' />
          <div className='irrigation-card__stat-block'>
            <span className='irrigation-card__stat-label'>
              {t('new_planner_recommendation_daily_return')}
            </span>
            <span className='irrigation-card__stat-value'>{dailyReturn}</span>
            <span className='irrigation-card__stat-unit'>
              {user_length_unit} (
              {t('new_planner_recommendation_daily_return_avg')})
            </span>
          </div>
        </div>
        <button
          onClick={onNext}
          disabled={isNextDisabled}
          aria-label='Next week'
          className='irrigation-card__arrow'
        >
          <img
            src={require('images/icons/Chevron_right.svg')}
            alt='Next week'
            style={{ width: 16, height: 16 }}
          />
        </button>
      </div>
    </div>
  );
};

module.exports = IrrigationRecommendationCard;
